import { useState } from "react";
import * as authApi from "../../api/auth";
import { STRENGTH_COLORS, passwordStrength } from "../../auth-validation";
import { setLoginPrefill } from "../../state/authPrefill";
import { PasswordInput } from "../../ui/PasswordInput";
import { AuthCard } from "./AuthCard";

/** Opened from the link in the reset email. */
export function ResetPasswordScreen({ token }: { token: string }) {
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const strength = pw ? passwordStrength(pw) : null;

  const submit = async () => {
    if (!token) { setError("This link is incomplete. Request a new one."); return; }
    if (strength === "Too short (min 8 chars)" || strength === "Weak") { setError(`Password is ${strength.toLowerCase()}. Choose a stronger password.`); return; }
    if (pw !== confirm) { setError("Passwords do not match."); return; }
    setBusy(true);
    setError("");
    try {
      await authApi.resetPassword(token, pw);
      setLoginPrefill("");
      setDone(true);
    } catch (e) {
      setError((e as Error).message);
    } finally { setBusy(false); }
  };

  return (
    <AuthCard>
      <h1>Choose a new password</h1>
      {done ? (
        <>
          <div className="sub" data-testid="reset-done">Your password has been changed and you have been signed out everywhere. Sign in with the new one.</div>
          <a className="btn primary" href="#/login" data-testid="to-login" style={{ textAlign: "center" }}>Go to sign in</a>
        </>
      ) : (
        <>
          <label className="caption" htmlFor="rs-pw">New password</label>
          <PasswordInput id="rs-pw" value={pw} onChange={setPw} placeholder="Min 8 characters" autoComplete="new-password" />
          <div className="strength" data-testid="strength" style={{ color: strength ? STRENGTH_COLORS[strength] : undefined, minHeight: 14 }}>{strength ?? ""}</div>
          <label className="caption" htmlFor="rs-pw2">Confirm password</label>
          <PasswordInput id="rs-pw2" value={confirm} onChange={setConfirm} placeholder="Repeat password" onEnter={submit} autoComplete="new-password" />
          <div className="error-text" role="alert" data-testid="reset-error">{error}</div>
          <button className="btn primary" disabled={busy} onClick={submit} data-testid="reset-submit">Change password</button>
        </>
      )}
    </AuthCard>
  );
}
